import { combineReducers } from "redux";
import notificationAlert from "./notificationState";
import filterData from './filterData'
import loaderStatus from './loaderState'
import notificationCount from './notificationCount'
import categoriesData from "./categories"

export default combineReducers({
  filterData,
  notificationAlert,
  loaderStatus,
  notificationCount,
  categoriesData

});